import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const LandingPage: React.FC = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const urlCode = searchParams.get('code');
    if (urlCode && urlCode.length === 8 && /^[a-zA-Z0-9]{8}$/.test(urlCode)) {
      setCode(urlCode);
      navigate(`/form/${urlCode}`);
    }
  }, [searchParams, navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (code.length !== 8) {
      setError('Koden måste vara exakt 8 tecken');
      return;
    }

    if (!/^[a-zA-Z0-9]{8}$/.test(code)) {
      setError('Koden får endast innehålla bokstäver och siffror');
      return;
    }

    navigate(`/form/${code}`);
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 8);
    setCode(value);
    setError('');
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>DaSaKlim Formulär</h1>
      <p>Ange din 8-ställiga kod för att komma åt formuläret</p>
      
      <form onSubmit={handleSubmit} style={{ maxWidth: '300px', margin: '0 auto' }}>
        <div className="form-group">
          <input
            type="text"
            value={code}
            onChange={handleCodeChange}
            placeholder="Ange 8-ställig kod"
            maxLength={8}
            autoFocus
            style={{ 
              fontSize: '18px', 
              textAlign: 'center', 
              letterSpacing: '2px',
              padding: '15px'
            }}
          />
          {error && <div className="error">{error}</div>}
        </div>
        
        <button 
          type="submit" 
          disabled={code.length !== 8}
          style={{ width: '100%', padding: '15px', fontSize: '16px' }}
        >
          Fortsätt till formulär
        </button>
      </form>
    </div>
  );
};

export default LandingPage;